<template>
	<!-- 订单核销 -->
	<div>
		<cube-page type="myorder-view" title="核销列表">
			<div slot="content">
				 核销列表
			</div>
		</cube-page>
		<cube-view></cube-view>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '@/components/TP/cube-page.vue'
	import * as util from '@/utils/network' 

	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return { 
			}
		},
		methods: {
		}
	}
</script>
<style type="text/css" lang="less">
	[class*=van-hairline]::after {
		border: none !important;
	}

	.van-grid-item__content {
		color: #969696;

		.van-icon {
			font-size: 40px;
		}

		.van-grid-item__text {
			color: #969696;
		}
	}

	.vgiactive {

		.van-grid-item__text,
		.van-icon {
			color: #07c160;
			font-weight: 600;
		}
	}
</style>
<style lang="less" scoped="scoped">
	.tt-wirte {
		padding: 20px;
		background-color: #FFFFFF;
	}

	.wirte-box {
		margin-top: 40px;
		padding: 0 15px;
	}

	.hsp {
		margin-top: 80px;
		font-size: 13px;
		color: #07c160;
		text-align: center;
	}
</style>
